export default __webpack_public_path__ + "static/media/page1-img_06.a3e85290.jpg";